import { layoutPositionedNodeSelector } from '../flowchartLayout/constants';
import { queryBoardNode } from '../../cardBitmaps/findTaskElement';

export function clearDropTargetHighlight(targetId) {
  if (!targetId) return;
  const element = queryBoardNode(layoutPositionedNodeSelector(targetId));
  if (element) {
    element.classList.remove('task-node--drop-target');
    element.classList.remove('decision-node--drop-target');
  }
}

export function applyDropTargetHighlight(targetId) {
  if (!targetId) return;
  const element = queryBoardNode(layoutPositionedNodeSelector(targetId));
  if (!element) return;
  if (element.classList.contains('decision-node')) {
    element.classList.add('decision-node--drop-target');
  } else {
    element.classList.add('task-node--drop-target');
  }
}

export function syncDropTargetHighlight(prevTargetId, nextTargetId) {
  if (prevTargetId === nextTargetId) return;
  clearDropTargetHighlight(prevTargetId);
  applyDropTargetHighlight(nextTargetId);
}
